import Vue from "vue";
import Router from "vue-router";

import Container from "./views/layout/Container";
import ProductList from "./views/Product/List/ProductList";
import ProductDetail from "./views/Product/Detail/ProductDetail";
import LoginPage from "./views/Auth/LoginPage";
import RegisterPage from "./views/Auth/RegisterPage";
import ForgotPassword from "./views/Auth/ForgotPassword";
import SettingPage from "./views/Setting/SettingPage";
import OrderList from "./views/Order/OrderList";
import OrderDetail from "./views/Order/OrderDetail"
import OrderConfirm from "./views/Order/OrderConfirm";
import OrderFinish from "./views/Order/OrderFinish";
import Logout401 from './views/Auth/Logout401';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      redirect: {name: 'ProductList'},
      name: 'Home',
      component: Container,
      children: [
        {
          path: "product/list",
          name: "ProductList",
          component: ProductList,
        },
        {
          path: "product/:product_id",
          name: "ProductDetail",
          component: ProductDetail,
        },
        {
          path: "order/list",
          name: "OrderList",
          component: OrderList,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "order/detail/:order_id",
          name: "OrderDetail",
          component: OrderDetail,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "order/confirm",
          name: "OrderConfirm",
          component: OrderConfirm,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "order/finish",
          name: "OrderFinish",
          component: OrderFinish,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "setting",
          name: "SettingPage",
          component: SettingPage,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: "forget",
          name: "ForgotPassword",
          component: ForgotPassword,
        },
        {
          path: "register",
          name: "Register",
          component: RegisterPage,
        },
        {
          path: "Logout401",
          name: "Logout401",
          component: Logout401,
        },
        {
          path: "login",
          name: "Login",
          component: LoginPage,
        }
      ]
    },
    {path: '*', redirect: {name: 'Home'}}
  ],
});

router.beforeEach((to, from, next) => {
  let routeAuth = to.matched.some(record => record.meta.requiresAuth);

  const token = localStorage.getItem("token");

  if (routeAuth && (routeAuth === true)) {
    if (!token) {
      if (from.name === 'Login') {
        return;
      }
      return next({replace: true, name: 'Login'});
    }
  }

  next();
});

export default router;
